import { getIntervalFromDates } from '@/utils';

export const handlePeriodSelected = (period, { dateRange }) => {
  const periodList = {
    'DAY': {
      label: 'DAY',
      activeIndex: 0,
    },
    'WEEK': {
      label: 'WEEK',
      activeIndex: 1,
    },
    'MONTH': {
      label: 'MONTH',
      activeIndex: 2,
    },
  };

  if (period) {
    return periodList[period];
  }

  const earlier = new Date(dateRange.start);
  const later = new Date(dateRange.end);
  const { days, months, years } = getIntervalFromDates(earlier, later);

  const greaterOrEqualOneMonthAndZeroDays = months >= 1 && days > 0;
  const greaterThanOneMonth = months > 1;
  const greaterThanOneYear = years > 0;

  if (greaterOrEqualOneMonthAndZeroDays || greaterThanOneMonth || greaterThanOneYear) {
    return periodList.WEEK;
  }

  return periodList.DAY;
};
